import appearance from "./assets/screenshots/appearance.png";
import bindings from "./assets/screenshots/bindings.png";
import configureFader from "./assets/screenshots/configure-fader.png";
import midiRoutes from "./assets/screenshots/midi-routes.png";
import onScreenDisplay from "./assets/screenshots/on-screen-display.png";
import plugins from "./assets/screenshots/plugins.png";
import targetPicker from "./assets/screenshots/target-picker-current.png";

export type DemoScreenId =
  | "bindings"
  | "midi-routes"
  | "target-picker"
  | "configure-fader"
  | "plugins"
  | "on-screen-display"
  | "appearance";

export type DemoScreen = {
  id: DemoScreenId;
  image: string;
  alt: string;
};

export const demoScreens: DemoScreen[] = [
  {
    id: "bindings",
    image: bindings,
    alt: "MIDIMaster bindings screen with fader and button bindings.",
  },
  {
    id: "midi-routes",
    image: midiRoutes,
    alt: "MIDIMaster bindings screen with the MIDI Routes panel open.",
  },
  {
    id: "target-picker",
    image: targetPicker,
    alt: "MIDIMaster target picker with built-in, integration, application, playback, and recording targets.",
  },
  {
    id: "configure-fader",
    image: configureFader,
    alt: "MIDIMaster fader configuration panel with curve, mute, assign, learn, and live value controls.",
  },
  {
    id: "plugins",
    image: plugins,
    alt: "MIDIMaster plugins screen with installed plugins and plugin categories.",
  },
  {
    id: "on-screen-display",
    image: onScreenDisplay,
    alt: "MIDIMaster on-screen display section with monitor, style, transparency, size, and position controls.",
  },
  {
    id: "appearance",
    image: appearance,
    alt: "MIDIMaster appearance section with theme presets, color controls, and customization sliders.",
  },
];

export const demoScreenshotSources = demoScreens.map((screen) => screen.image);

export function getDemoScreen(id: DemoScreenId) {
  return demoScreens.find((screen) => screen.id === id) ?? demoScreens[0];
}
